// import { ChevronLeft, Camera, Image as ImageIcon } from "lucide-react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useState, useRef, useEffect, useMemo } from "react";
// import { Button } from "@/components/ui/button";
// import { ImageWithLoader } from "@/components/ui/image-with-loader";
// import { useAuth } from "@/hooks/useAuth";
// import { uploadDocumentFile, useUpdateProfile } from "@/hooks/useUpdateProfile";
// import { useProfile } from "@/hooks/useProfile";
// import { ENV } from "@/constant";
// import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// function ProfilePhoto() {
//   const { state } = useLocation();
//   const navigate = useNavigate();
//   const form = state?.formData || {};
//   const [capturedImage, setCapturedImage] = useState<string | null>(null);
//   const [cameraError, setCameraError] = useState<string | null>(null);
//   const cameraInputRef = useRef<HTMLInputElement>(null);
//   const libraryInputRef = useRef<HTMLInputElement>(null);
//   const videoRef = useRef<HTMLVideoElement>(null);
//   const streamRef = useRef<MediaStream | null>(null);
//   const [selectedFile, setSelectedFile] = useState<File | null>(null);
//   const [user, setUser] = useState<any>({});
//   const [isUploading, setIsUploading] = useState(false);
//   const [cameraOpen, setCameraOpen] = useState(false);
//   const { updateProfile } = useUpdateProfile();
//   const BASE_URL = ENV.VITE_BASE_URL;
//   const { token } = useAuth();
//   const { profile, mutate: refreshProfile } = useProfile();
//   const { uploadFile } = uploadDocumentFile();

//   const handleBack = () => {
//     navigate('/forms');
//   };

//   useEffect(() => {
//     setUser(profile);
//   }, [JSON.stringify(profile)]);

//   useEffect(() => {
//     const avatarUrl = profile?.avatar || profile?.profile?.avatar;
//     if (!avatarUrl) return;
//     const isDataUrl = capturedImage?.startsWith("data:");
//     if (isDataUrl) return;
//     if (capturedImage !== avatarUrl) {
//       setCapturedImage(`${avatarUrl}?v=${Date.now()}`);
//     }
//   }, [profile?.avatar, profile?.profile?.avatar]);

//   const displayImage = useMemo(() => {
//     if (!capturedImage) return null;
//     if (capturedImage.startsWith('data:')) return capturedImage;
//     const version =
//       profile?.profile?.updatedAt || profile?.updatedAt || (profile?.updated_at as string) || '';
//     const sep = capturedImage.includes('?') ? '&' : '?';
//     return version ? `${capturedImage}${sep}v=${encodeURIComponent(String(version))}` : capturedImage;
//   }, [capturedImage, profile?.profile?.updatedAt, profile?.updatedAt, profile?.updated_at]);



//   const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
//     const file = event.target.files?.[0];
//     if (!file) return;
//     if (!file.type.startsWith('image/')) {
//       setCameraError('Please select an image file.');
//       return;
//     }
//     setSelectedFile(file);
//     const reader = new FileReader();
//     reader.onload = (e) => {
//       setCapturedImage(e.target?.result as string);
//       setCameraError(null);
//     };
//     reader.readAsDataURL(file);
//   };
// //  const handleFileUpload1 = (event: React.ChangeEvent<HTMLInputElement>) => {
// //     console.log("fndsjkgdjkgjkds12",libraryInputRef.current?.value);
// //       if(
// //       !libraryInputRef.current?.value
// //     ) {
// //       setCameraError("Camera access was denied. Please allow camera access in your device settings." )
// //       return;
// //     }
// //     console.log("cameraInputRef",cameraInputRef
// //     )
// //     const file = event.target.files?.[0];
// //     if (file && file.type.startsWith('image/') && libraryInputRef.current?.value) {
// //       setSelectedFile(file);
// //       const reader = new FileReader();
// //       reader.onload = (e) => {
// //         setCapturedImage(e.target?.result as string);
// //         setCameraError(null);
// //       };
// //       reader.readAsDataURL(file);
// //     }
// //   };
//   const resetPhoto = () => {
//     setCapturedImage(null);
//     setCameraError(null);
//     setSelectedFile(null);
//     if (cameraInputRef.current) cameraInputRef.current.value = '';
//     if (libraryInputRef.current) libraryInputRef.current.value = '';
//   };

//   const isMobileDevice = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

//   // const startCamera = async () => {
//   //   if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
//   //     setCameraError('Camera not supported in this browser.');
//   //     // Fallback to file input
//   //     cameraInputRef.current?.click();
//   //     return;
//   //   }
//   //   try {
//   //     // Open modal first so the <video> mounts before we attach stream
//   //     setCameraOpen(true);
//   //     // Prefer front camera when available
//   //     const constraints: MediaStreamConstraints = {
//   //       video: true,
//   //       audio: true,
//   //     };
//   //     let stream = await navigator.mediaDevices.getUserMedia(constraints);
//   //     // Some laptops may not honor facingMode; ensure we have a stream, else retry with generic
//   //     if (!stream) {
//   //       stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
//   //     }
//   //     streamRef.current = stream;
//   //     // Attach will occur in useEffect when modal is open and video is mounted
//   //     setCameraError(null);
//   //   } catch (err: any) {
//   //     let message = 'Unable to access camera.';
//   //     if (err?.name === 'NotAllowedError') message = 'Camera permission denied. Enable it in browser settings.';
//   //     if (location.protocol !== 'https:' && location.hostname !== 'localhost') {
//   //       message = 'Camera requires https. Please use a secure origin.';
//   //     }
//   //     setCameraError(message);
//   //     setCameraOpen(false);
//   //     // Fallback to file input on failure
//   //     cameraInputRef.current?.click();
//   //   }
//   // };
// const startCamera = async () => {
//   if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
//     setCameraError('Camera not supported in this browser.');
//     cameraInputRef.current?.click();
//     return;
//   }

//   try {
//     // Open modal first
//     setCameraOpen(true);

//     // Small delay to ensure video element is mounted
//     await new Promise(resolve => setTimeout(resolve, 100));

//     // Use environment-facing camera (front camera)
//     const constraints: MediaStreamConstraints = {
//       video: {
//         facingMode: 'user', // 'user' for front camera, 'environment' for back
//         width: { ideal: 1280 },
//         height: { ideal: 720 }
//       },
//       audio: false
//     };

//     const stream = await navigator.mediaDevices.getUserMedia(constraints);
//     streamRef.current = stream;

//     // Attach stream to video element
//     if (videoRef.current) {
//       videoRef.current.srcObject = stream;
//       videoRef.current.onloadedmetadata = () => {
//         videoRef.current?.play().catch(e => {
//           console.error("Error playing video:", e);
//           setCameraError('Could not start camera feed.');
//         });
//       };
//     }

//     setCameraError(null);
//   } catch (err: any) {
//     console.error("Camera error:", err);
//     let message = 'Unable to access camera.';
//     if (err?.name === 'NotAllowedError') {
//       message = 'Camera permission denied. Please enable camera access in your browser settings.';
//     } else if (err?.name === 'NotFoundError') {
//       message = 'No camera found. Please check your device.';
//     } else if (location.protocol !== 'https:' && location.hostname !== 'localhost') {
//       message = 'Camera requires HTTPS. Please use a secure connection.';
//     }
//     setCameraError(message);
//     setCameraOpen(false);
//     cameraInputRef.current?.click();
//   }
// };
//   const stopCamera = () => {
//     if (streamRef.current) {
//       streamRef.current.getTracks().forEach((t) => t.stop());
//       streamRef.current = null;
//     }
//     if (videoRef.current) {
//       try {
//         videoRef.current.srcObject = null;
//       } catch {
//         (videoRef.current as any).srcObject = null;
//       }
//     }
//   };
// const captureFromVideo = () => {
//   if (!videoRef.current || !streamRef.current) return;

//   const video = videoRef.current;

//   // Ensure video has valid dimensions
//   if (video.videoWidth === 0 || video.videoHeight === 0) {
//     setCameraError('Video not ready yet. Please wait a moment.');
//     return;
//   }

//   const canvas = document.createElement('canvas');
//   canvas.width = video.videoWidth;
//   canvas.height = video.videoHeight;

//   const ctx = canvas.getContext('2d');
//   if (!ctx) {
//     setCameraError('Could not capture image.');
//     return;
//   }

//   // Draw the current video frame
//   ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

//   // Convert to data URL
//   const dataUrl = canvas.toDataURL('image/jpeg', 0.92);
//   setCapturedImage(dataUrl);
//   setCameraError(null);

//   // Clean up
//   stopCamera();
//   setCameraOpen(false);
// };
//   // const captureFromVideo = () => {
//   //   if (!videoRef.current) return;
//   //   const video = videoRef.current as HTMLVideoElement;
//   //   const canvas = document.createElement('canvas');
//   //   const width = video.videoWidth || 720;
//   //   const height = video.videoHeight || 720;
//   //   canvas.width = width;
//   //   canvas.height = height;
//   //   const ctx = canvas.getContext('2d');
//   //   if (!ctx) return;
//   //   ctx.drawImage(video, 0, 0, width, height);
//   //   const dataUrl = canvas.toDataURL('image/jpeg', 0.92);
//   //   setCapturedImage(dataUrl);
//   //   setCameraError(null);
//   //   setCameraOpen(false);
//   //   stopCamera();
//   // };

//   useEffect(() => {
//     return () => {
//       stopCamera();
//     };
//   }, []);
// useEffect(() => {
//   if (cameraOpen && videoRef.current && streamRef.current) {
//     const video = videoRef.current;
//     video.srcObject = streamRef.current;

//     video.onloadedmetadata = () => {
//       video.play().catch(e => {
//         console.error("Auto-play failed:", e);
//         // Try muted autoplay
//         video.muted = true;
//         video.play().catch(e2 => {
//           console.error("Muted auto-play also failed:", e2);
//         });
//       });
//     };

//     // If video already has metadata
//     if (video.readyState >= 1) {
//       video.play().catch(e => console.error("Play error:", e));
//     }
//   }
// }, [cameraOpen]);
//   // useEffect(() => {
//   //   // When dialog opens and we have a stream, attach to the video element
//   //   if (cameraOpen && videoRef.current && streamRef.current) {
//   //     const video = videoRef.current;
//   //     try {
//   //       video.srcObject = streamRef.current;
//   //     } catch {
//   //       (video as any).srcObject = streamRef.current;
//   //     }
//   //     const tryPlay = async () => {
//   //       try {
//   //         await video.play();
//   //       } catch {
//   //         // ignore autoplay errors
//   //       }
//   //     };
//   //     if (video.readyState >= 2) {
//   //       tryPlay();
//   //     } else {
//   //       video.onloadedmetadata = () => {
//   //         tryPlay();
//   //       };
//   //     }
//   //   }
//   // }, [cameraOpen]);

//   const handlePhotoAction = () => {
//     // On mobile, let the input with capture open the camera.
//     // if (isMobileDevice()) {
//     //   if (cameraInputRef.current) {
//     //     cameraInputRef.current.value = '';
//     //     cameraInputRef.current.click();
//     //   }
//     //   return;
//     // }
//     // On desktop, open custom camera modal using getUserMedia
//     startCamera();
//   };

//   const handlePickFromLibrary = () => {
//     // Open library/files picker (no capture attr)
//     if (libraryInputRef.current) {
//       libraryInputRef.current.value = '';
//       libraryInputRef.current.click();
//     }
//   };

//   function base64ToBlob(base64: string) {
//     const parts = base64.split(",");
//     const header = parts[0] ?? "";
//     const match = header.match(/:(.*?);/);
//     const mime = match && typeof match[1] !== 'undefined' && match[1] !== '' ? match[1] : 'image/jpeg';
//     const b64Data = parts[1] ?? "";
//     const bstr = b64Data ? atob(b64Data) : "";
//     let n = bstr.length;
//     const u8arr = new Uint8Array(n);
//     for (let i = 0; i < n; i++) {
//       u8arr[i] = bstr.charCodeAt(i);
//     }

//     const blob = new Blob([u8arr], { type: mime });
//     const file = new File([blob], "profile-photo.jpg", { type: mime });

//     return file;
//   }

//   const handleSubmit = async () => {
//     if (!capturedImage && !selectedFile) {
//       alert("Please take or upload a photo first.");
//       return;
//     }

//     try {
//       setIsUploading(true);
//       let fileToUpload: File;
//       if (selectedFile) {
//         fileToUpload = selectedFile;
//       } else if (capturedImage && capturedImage.startsWith('data:')) {
//         fileToUpload = base64ToBlob(capturedImage);
//       } else {
//         alert('Please take or upload a photo first.');
//         return;
//       }

//       const result = await uploadFile(fileToUpload);

//       if (result?.data?.fileLink) {
//         setUser({
//           ...user,
//           avatar: result.data.fileLink,
//         });

//         const res = await updateProfile({
//           avatar: result.data.fileLink,
//         });

//         if (res && res.success) {
//           await refreshProfile();
//           alert("Profile Photo submitted successfully!");
//           navigate('/forms');
//         }
//       } else {
//         alert("⚠️ Upload succeeded, but no file link found.");
//       }
//     } catch (error) {
//       console.error("Error in handleSubmit:", error);
//       if (error instanceof Error) {
//         alert("Error uploading photo:\n" + error.message);
//       } else {
//         alert("Error uploading photo. Please try again.");
//       }
//     } finally {
//       setIsUploading(false);
//     }
//   };

//   return (
//     <div className="">
//       {/* Header */}
//       <div className="flex items-center justify-between p-4 border-b bg-white text-black">
//         <div onClick={handleBack} className="cursor-pointer">
//           <ChevronLeft />
//         </div>
//         <div className="flex-1 text-center">
//           <h1 className="text-lg font-semibold">{form?.header || "Profile Photo"}</h1>
//         </div>
//         <div className="w-6"></div>
//       </div>

//       {/* Content */}
//       <div className="flex p-4 flex-col items-center space-y-6">
//         {/* Title & Instructions */}
//         <div className="space-y-3">
//           <h2 className="text-xl font-semibold">Take your profile photo</h2>
//           <p className="text-sm text-gray-700">
//             <span className="font-semibold">Note:</span> Once you submit the profile photo, it cannot be changed.
//             Please make sure it is an accurate representation of yourself before uploading.
//           </p>
//           <ul className="text-sm text-gray-700 text-left list-decimal list-inside mt-2 space-y-1">
//             <li>Show your whole face and tops of your shoulders.</li>
//             <li>Take your sunglasses and hat off.</li>
//             <li>Take your photo in a well-lit place.</li>
//           </ul>
//         </div>

//         {/* Camera Error Alert */}
//         {cameraError && (
//           <div className="w-full bg-yellow-50 border border-yellow-200 rounded-lg p-3">
//             <p className="text-sm text-yellow-800">{cameraError}</p>
//             <p className="text-xs text-yellow-700 mt-1">
//               You can still upload a photo from your device using the "Choose from Library" button.
//             </p>
//           </div>
//         )}

//         {/* Photo Placeholder or Preview */}
//         <div
//           className="w-40 h-40 rounded-full border-2 border-gray-400 flex items-center justify-center cursor-pointer hover:border-blue-500 transition overflow-hidden"
//           onClick={handlePhotoAction}
//         >
//           {capturedImage ? (
//             <ImageWithLoader
//               key={displayImage || capturedImage || 'avatar'}
//               src={displayImage || undefined}
//               alt="Profile"
//               containerClassName="w-full h-full overflow-hidden"
//               className="object-cover rounded-full"
//               onError={(e) => {
//                 const img = e.currentTarget as HTMLImageElement;
//                 if (displayImage && capturedImage && displayImage !== capturedImage) {
//                   img.src = capturedImage;
//                 }
//               }}
//             />
//           ) : (
//             <span className="text-gray-400 text-sm">No Image</span>
//           )}
//         </div>

//         {/* Action Buttons */}
//         <div className="w-full space-y-3">
//           <button
//             onClick={handlePhotoAction}
//             disabled={isUploading}
//             className="w-full bg-blue-500 text-white py-2 rounded-lg font-medium hover:bg-blue-600 disabled:opacity-60 disabled:cursor-not-allowed transition flex items-center justify-center space-x-2"
//           >
//             <Camera size={18} />
//             <span>Take Photo</span>
//           </button>
//           <button
//             onClick={handlePickFromLibrary}
//             disabled={isUploading}
//             className="w-full bg-gray-100 text-gray-900 py-2 rounded-lg font-medium hover:bg-gray-200 disabled:opacity-60 disabled:cursor-not-allowed transition flex items-center justify-center space-x-2"
//           >
//             <ImageIcon size={18} />
//             <span>Choose from Library</span>
//           </button>
//         </div>

//         {/* Reset Button */}
//         {capturedImage && (
//           <button
//             onClick={resetPhoto}
//             disabled={isUploading}
//             className="w-full bg-red-100 text-red-700 py-2 rounded-lg font-medium hover:bg-red-200 disabled:opacity-60 disabled:cursor-not-allowed transition"
//           >
//             Retake Photo
//           </button>
//         )}

//         {/* Submit Button */}
//         <Button
//           className="w-full mt-6"
//           onClick={handleSubmit}
//           type="submit"
//           disabled={isUploading || !capturedImage}
//         >
//           {isUploading ? 'Uploading...' : 'Submit'}
//         </Button>
//       </div>

//       {/* Uploading overlay */}
//       {isUploading && (
//         <div className="fixed inset-0 bg-black/30 backdrop-blur-[1px] flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg shadow p-4 flex items-center space-x-3">
//             <svg className="animate-spin h-5 w-5 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//               <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//               <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
//             </svg>
//             <span className="text-sm font-medium">Uploading photo…</span>
//           </div>
//         </div>
//       )}

//       {/* Camera Modal for desktop */}
//       <Dialog open={cameraOpen} onOpenChange={(open) => {
//         setCameraOpen(open);
//         if (!open) stopCamera();
//       }}>
//         <DialogContent className="max-w-md p-0 overflow-hidden">
//           <DialogHeader className="px-4 pt-4">
//             <DialogTitle>Take Photo</DialogTitle>
//           </DialogHeader>
//           <div className="relative w-full">
//             <video
//               ref={videoRef}
//               autoPlay
//               playsInline
//               // muted
//               className="w-full h-[80vh] max-h-[80vh] object-contain"
//             />
//             <div className="flex items-center justify-between gap-3 p-4">
//               <button
//                 type="button"
//                 onClick={() => { setCameraOpen(false); stopCamera(); }}
//                 className="flex-1 bg-gray-100 text-gray-900 py-2 rounded-lg font-medium hover:bg-gray-200"
//               >
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 onClick={captureFromVideo}
//                 className="flex-1 bg-blue-600 text-white py-2 rounded-lg font-medium hover:bg-blue-700"
//               >
//                 Capture
//               </button>
//             </div>
//           </div>
//         </DialogContent>
//       </Dialog>

//       {/* Hidden inputs: camera vs library */}
//       <input
//         type="file"
//         ref={cameraInputRef}
//         onChange={handleFileUpload}
//         accept="image/*"
//         capture="user"
//         className="hidden"
//       />
//       <input
//         type="file"
//         ref={libraryInputRef}
//         onChange={handleFileUpload}
//         accept="image/*"
//         className="hidden"
//       />
//     </div>
//   );
// }

// export default ProfilePhoto;

import { ChevronLeft, Camera, Image as ImageIcon } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useState, useRef, useEffect, useMemo } from "react";
import { Button } from "@/components/ui/button";
import { ImageWithLoader } from "@/components/ui/image-with-loader";
import { useAuth } from "@/hooks/useAuth";
import { uploadDocumentFile, useUpdateProfile } from "@/hooks/useUpdateProfile";
import { useProfile } from "@/hooks/useProfile";
import { ENV } from "@/constant";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

function ProfilePhoto() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const form = state?.formData || {};
  const [capturedImage, setCapturedImage] = useState<string | null>(null);
  const [cameraError, setCameraError] = useState<string | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [user, setUser] = useState<any>({});
  const [isUploading, setIsUploading] = useState(false);
  const [cameraOpen, setCameraOpen] = useState(false);
  const { updateProfile } = useUpdateProfile();
  const BASE_URL = ENV.VITE_BASE_URL;
  const { token } = useAuth();
  const { profile, mutate: refreshProfile } = useProfile();
  const { uploadFile } = uploadDocumentFile();

  const MAX_IMAGE_BYTES = 1 * 1024 * 1024; // 1 MB

  const handleBack = () => {
    // navigate('/forms', { replace: true });
    navigate(-1);
  };

  useEffect(() => {
    setUser(profile);
  }, [JSON.stringify(profile)]);

  useEffect(() => {
    const avatarUrl = profile?.avatar || profile?.profile?.avatar;
    if (!avatarUrl) return;
    const isDataUrl = capturedImage?.startsWith("data:");
    if (isDataUrl) return;
    if (capturedImage !== avatarUrl) {
      setCapturedImage(`${avatarUrl}?v=${Date.now()}`);
    }
  }, [profile?.avatar, profile?.profile?.avatar]);

  const displayImage = useMemo(() => {
    if (!capturedImage) return null;
    if (capturedImage.startsWith('data:')) return capturedImage;
    const version =
      profile?.profile?.updatedAt || profile?.updatedAt || (profile?.updated_at as string) || '';
    const sep = capturedImage.includes('?') ? '&' : '?';
    return version ? `${capturedImage}${sep}v=${encodeURIComponent(String(version))}` : capturedImage;
  }, [capturedImage, profile?.profile?.updatedAt, profile?.updatedAt, profile?.updated_at]);

  // Image compression function (same as in RenderForm)
  async function compressImage(file: File, maxBytes: number): Promise<File> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const url = URL.createObjectURL(file);

      img.onload = () => {
        URL.revokeObjectURL(url);

        let width = img.naturalWidth || img.width;
        let height = img.naturalHeight || img.height;

        // Calculate new dimensions while maintaining aspect ratio
        const maxDimension = 2048;
        if (width > maxDimension || height > maxDimension) {
          const scale = maxDimension / Math.max(width, height);
          width = Math.floor(width * scale);
          height = Math.floor(height * scale);
        }

        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        if (!ctx) {
          reject(new Error("Could not create canvas context"));
          return;
        }

        ctx.drawImage(img, 0, 0, width, height);

        let quality = 0.9;
        let attempts = 0;
        const minQuality = 0.4;

        const tryCompress = () => {
          canvas.toBlob((blob) => {
            if (!blob) {
              reject(new Error("Failed to create blob"));
              return;
            }

            if (blob.size <= maxBytes || quality <= minQuality || attempts >= 5) {
              const compressedFile = new File([blob], file.name, {
                type: "image/jpeg",
                lastModified: Date.now(),
              });
              resolve(compressedFile);
            } else {
              quality -= 0.1;
              attempts++;
              setTimeout(tryCompress, 0);
            }
          }, "image/jpeg", quality);
        };

        tryCompress();
      };

      img.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error("Failed to load image"));
      };

      img.src = url;
    });
  }

  const handleFileSelect = async (source: 'camera' | 'library') => {
    const input = document.createElement("input");
    input.type = "file";

    // Only allow images for camera capture. Library can select images.
    input.accept = "image/*";

    if (source === 'camera') {
      input.setAttribute('capture', 'camera');
    }

    input.style.position = "fixed";
    input.style.top = "-10000px";
    input.style.left = "-10000px";
    input.value = "";
    document.body.appendChild(input);

    input.onchange = async (e: any) => {
      const file = e.target.files?.[0];
      if (!file) {
        input.value = "";
        document.body.removeChild(input);
        return;
      }

      setIsUploading(true);
      setCameraError(null);

      try {
        if (file.type.startsWith("image/")) {
          let finalFile = file;

          // Always compress images if they're over 1MB
          if (file.size > MAX_IMAGE_BYTES) {
            try {
              finalFile = await compressImage(file, MAX_IMAGE_BYTES);
              console.log(`Compressed from ${file.size} to ${finalFile.size} bytes`);
            } catch (err) {
              console.error("Image compression failed:", err);
              // Fall back to original file if compression fails
            }
          }

          // Check if the (compressed) file is still too large
          if (finalFile.size > MAX_IMAGE_BYTES) {
            setCameraError(`Image is too large (${(finalFile.size / 1024 / 1024).toFixed(2)}MB). Please try again with better lighting or lower resolution.`);
            setIsUploading(false);
            return;
          }

          // Set the field value with the final (possibly compressed) file
          setSelectedFile(finalFile);

          // Create preview
          const reader = new FileReader();
          reader.onload = (e) => {
            setCapturedImage(e.target?.result as string);
          };
          reader.readAsDataURL(finalFile);

        } else {
          setCameraError("Unsupported file type. Please select an image.");
        }
      } catch (error) {
        console.error("Error handling file:", error);
        setCameraError("Failed to process file. Please try again.");
      } finally {
        setIsUploading(false);
        input.value = "";
        setTimeout(() => {
          if (input.parentNode) document.body.removeChild(input);
        }, 0);
      }
    };

    input.click();
  };

  const resetPhoto = () => {
    setCapturedImage(null);
    setCameraError(null);
    setSelectedFile(null);
  };

  function base64ToBlob(base64: string) {
    const parts = base64.split(",");
    const header = parts[0] ?? "";
    const match = header.match(/:(.*?);/);
    const mime = match && typeof match[1] !== 'undefined' && match[1] !== '' ? match[1] : 'image/jpeg';
    const b64Data = parts[1] ?? "";
    const bstr = b64Data ? atob(b64Data) : "";
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    for (let i = 0; i < n; i++) {
      u8arr[i] = bstr.charCodeAt(i);
    }

    const blob = new Blob([u8arr], { type: mime });
    const file = new File([blob], "profile-photo.jpg", { type: mime });

    return file;
  }

  const handleSubmit = async () => {
    // Check if we have a NEW photo (not just the existing backend one)
    if (!capturedImage) {
      alert("Please take or upload a photo first.");
      return;
    }

    // Check if this is just the existing backend image (URL) without a new upload
    const isExistingBackendImage = capturedImage &&
      !capturedImage.startsWith('data:') &&
      !selectedFile;

    if (isExistingBackendImage) {

      alert('This photo is already uploaded. Please take or upload a new photo to update.');
      return;
    }

    try {
      setIsUploading(true);
      let fileToUpload: File;

      // Priority: use selectedFile if available, otherwise convert base64
      if (selectedFile) {
        fileToUpload = selectedFile;
      } else if (capturedImage.startsWith('data:')) {
        fileToUpload = base64ToBlob(capturedImage);
      } else {
        // Fallback safety check
        alert('Please take or upload a new photo.');
        setIsUploading(false);
        return;
      }

      const result = await uploadFile(fileToUpload);

      if (result?.data?.fileLink) {
        setUser({
          ...user,
          avatar: result.data.fileLink,
        });

        const res = await updateProfile({
          avatar: result.data.fileLink,
        });

        if (res && res.success) {
          await refreshProfile();
          alert("Profile Photo submitted successfully!");
          navigate('/forms', { replace: true });
        } else {
          alert("Failed to update profile. Please try again.");
        }
      } else {
        alert("⚠️ Upload succeeded, but no file link found.");
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      if (error instanceof Error) {
        alert("Error uploading photo:\n" + error.message);
      } else {
        alert("Error uploading photo. Please try again.");
      }
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b bg-white dark:bg-slate-900 text-black dark:text-white">
        <div onClick={handleBack} className="cursor-pointer">
          <ChevronLeft />
        </div>
        <div className="flex-1 text-center">
          <h1 className="text-lg font-semibold">{form?.header || "Profile Photo"}</h1>
        </div>
        <div className="w-6"></div>
      </div>

      {/* Content */}
      <div className="flex p-4 flex-col items-center space-y-6">
        {/* Title & Instructions */}
        <div className="space-y-3">
          <h2 className="text-xl font-semibold">Take your profile photo</h2>
          <p className="text-sm text-gray-700">
            <span className="font-semibold">Note:</span> Once you submit the profile photo, it cannot be changed.
            Please make sure it is an accurate representation of yourself before uploading.
          </p>
          <ul className="text-sm text-gray-700 text-left list-decimal list-inside mt-2 space-y-1">
            <li>Show your whole face and tops of your shoulders.</li>
            <li>Take your sunglasses and hat off.</li>
            <li>Take your photo in a well-lit place.</li>
          </ul>
        </div>

        {/* Camera Error Alert */}
        {cameraError && (
          <div className="w-full bg-yellow-50 border border-yellow-200 rounded-lg p-3">
            <p className="text-sm text-yellow-800">{cameraError}</p>
            <p className="text-xs text-yellow-700 mt-1">
              You can still upload a photo from your device using the "Choose from Library" button.
            </p>
          </div>
        )}

        {/* Photo Placeholder or Preview */}
        <div
          className="w-40 h-40 rounded-full border-2 border-gray-400 flex items-center justify-center cursor-pointer hover:border-blue-500 transition overflow-hidden"
          onClick={() => handleFileSelect('library')

          }
        >
          {capturedImage ? (
            <ImageWithLoader
              key={displayImage || capturedImage || 'avatar'}
              src={displayImage || undefined}
              alt="Profile"
              containerClassName="w-full h-full overflow-hidden"
              className="object-cover rounded-full"
              onError={(e) => {
                const img = e.currentTarget as HTMLImageElement;
                if (displayImage && capturedImage && displayImage !== capturedImage) {
                  img.src = capturedImage;
                }
              }}
            />
          ) : (
            <span className="text-gray-400 text-sm">No Image</span>
          )}
        </div>

        {/* Action Buttons */}
        <div className="w-full space-y-3">
          <button
            onClick={() => handleFileSelect('camera')}
            disabled={isUploading}
            className="w-full bg-blue-500 text-white py-2 rounded-lg font-medium hover:bg-blue-600 disabled:opacity-60 disabled:cursor-not-allowed transition flex items-center justify-center space-x-2"
          >
            <Camera size={18} />
            <span>Take Photo</span>
          </button>
          {/* <button
            onClick={() => handleFileSelect('library')}
            disabled={isUploading}
            className="w-full bg-gray-100 text-gray-900 py-2 rounded-lg font-medium hover:bg-gray-200 disabled:opacity-60 disabled:cursor-not-allowed transition flex items-center justify-center space-x-2"
          >
            <ImageIcon size={18} />
            <span>Choose from Library</span>
          </button> */}
        </div>

        {/* Reset Button */}
        {/* {capturedImage && (
          <button
            onClick={resetPhoto}
            disabled={isUploading}
            className="w-full bg-red-100 text-red-700 py-2 rounded-lg font-medium hover:bg-red-200 disabled:opacity-60 disabled:cursor-not-allowed transition"
          >
            Retake Photo
          </button>
        )} */}

        {/* Submit Button */}
        <Button
          className="w-full mt-0"
          onClick={handleSubmit}
          type="submit"
          disabled={isUploading || !capturedImage}
        >
          {isUploading ? 'Uploading...' : 'Submit'}
        </Button>
      </div>

      {/* Uploading overlay */}
      {isUploading && (
        <div className="fixed inset-0 bg-black/30 backdrop-blur-[1px] flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow p-4 flex items-center space-x-3">
            <svg className="animate-spin h-5 w-5 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
            </svg>
            <span className="text-sm font-medium">Uploading photo…</span>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProfilePhoto;